import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import * as _ from 'lodash';

import { SuccessUploadModalComponent } from '../success-upload-modal/success-upload-modal.component';
import { UploadAssetsModalComponent } from '../upload-assets-modal/upload-assets-modal.component';


@Component({
  moduleId: module.id,
  selector: 'upload-assets',
  templateUrl: 'upload-assets.component.html',
})
export class UploadAssetsComponent {

  @Output() uploadingDone: EventEmitter<any> = new EventEmitter();
  @Output() assetsUploaded: EventEmitter<any> = new EventEmitter();
  @Output() assetsSaved: EventEmitter<any> = new EventEmitter();

  @Input() isEditable: boolean = false;

  @ViewChild(SuccessUploadModalComponent, {static: false})
  successModal: SuccessUploadModalComponent | void;

  @ViewChild(UploadAssetsModalComponent, {static: false})
  uploadAssetsModal: UploadAssetsModalComponent | void;

  onUploadModalClosed() {
    this.uploadingDone.emit();
  }

  onSuccessModalShow() {
    if (this.uploadAssetsModal instanceof UploadAssetsModalComponent) {
      this.uploadAssetsModal.hide();
    }
    _.delay(() => {
      if (this.successModal instanceof SuccessUploadModalComponent) {
        this.successModal.show();
      }
    }, 200);
  }

  onSuccessModalHide() {
    this.uploadingDone.emit();
  }

  onAssetsUploaded(asset: any) {
    this.assetsUploaded.emit(asset);
  }

  onAssetsSaved(assets: any[]) {
    this.assetsSaved.emit(assets);
  }

  public showUploadModal(): void {
    if (this.uploadAssetsModal instanceof UploadAssetsModalComponent) {
      this.uploadAssetsModal.show();
    }
  }

}
